import {
  withCompInfo,
  withStateRefsValues,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations/siteAssets';

import type { ITextParticlesDefinition } from '../documentManagement/TextParticles.definition';
import type { TextParticlesProps } from '../TextParticles.types';

export const props = withCompInfo<
  TextParticlesProps,
  ITextParticlesDefinition
>()(['compData'], ({ compData }) => {
  return {
    ...compData,
  };
});

export const stateRefs = withStateRefsValues([
  'editorType',
  'reducedMotion',
  'currentUrlWithQueryParams',
]);

export default createComponentMapperModel({ props, stateRefs });
